import React, { useRef } from "react";
import gsap from "gsap";
import useBreakpoint from "../../../hooks/useBreakpoint";
var ArrowSvg = function ArrowSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M13.887 10.842H3.744V9.176h10.143l-4.47-4.47 1.179-1.179 6.482 6.482-6.482 6.482-1.179-1.179 4.47-4.47Z",
    fill: "#212121"
  }));
};
ArrowSvg.defaultProps = {
  width: "20",
  height: "20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import IconAtm from "../../atoms/IconAtm";
import RoundedCornerIconAtm from "../../atoms/RoundedCornerIconAtm";
import { BackTile, BottomRoundedCorner, Button, ButtonWrapper, FrontTile, Icon, ImageWrapper, TopRoundedCorner, Wrapper } from "./CategoryCardMol.styled";
export var roundedCornerIconSize = 20;
function CategoryCardMol(_ref) {
  var image = _ref.image,
    backTileColor = _ref.backTileColor,
    title = _ref.title,
    promoPrefix = _ref.promoPrefix,
    promoInfo = _ref.promoInfo,
    onClick = _ref.onClick,
    backgroundColor = _ref.backgroundColor,
    hasImageStuckToRight = _ref.hasImageStuckToRight;
  var backTileRef = useRef(null);
  var imageRef = useRef(null);
  var buttonIconRef = useRef(null);
  var isMediumUp = useBreakpoint("medium");
  var handleMouseEnter = function handleMouseEnter() {
    if (isMediumUp) {
      var timeLine = gsap.timeline();
      timeLine.to(backTileRef.current, {
        yPercent: 7,
        ease: "slow"
      }, 0);
      timeLine.to(imageRef.current, {
        scale: 1.1,
        ease: "slow"
      }, 0);
      timeLine.to(buttonIconRef.current, {
        rotationZ: -45
      }, 0);
    }
  };
  var handleMouseLeave = function handleMouseLeave() {
    if (isMediumUp) {
      var timeLine = gsap.timeline();
      timeLine.to(backTileRef.current, {
        yPercent: 0,
        ease: "slow"
      }, 0);
      timeLine.to(imageRef.current, {
        scale: 1,
        ease: "slow"
      }, 0);
      timeLine.to(buttonIconRef.current, {
        rotationZ: 0
      }, 0);
    }
  };
  return /*#__PURE__*/React.createElement(Wrapper, {
    $backgroundColor: backgroundColor,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    onClick: onClick
  }, /*#__PURE__*/React.createElement(BackTile, {
    ref: backTileRef,
    $backgroundColor: backTileColor,
    $hasImageStuckToRight: hasImageStuckToRight
  }, /*#__PURE__*/React.createElement(ImageWrapper, {
    ref: imageRef
  }, image)), /*#__PURE__*/React.createElement(FrontTile, null, title, promoPrefix, promoInfo, /*#__PURE__*/React.createElement(ButtonWrapper, {
    $backgroundColor: backgroundColor
  }, /*#__PURE__*/React.createElement(TopRoundedCorner, {
    $size: roundedCornerIconSize,
    $backgroundColor: backgroundColor
  }, /*#__PURE__*/React.createElement(RoundedCornerIconAtm, {
    size: roundedCornerIconSize,
    color: backgroundColor
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(Icon, {
    ref: buttonIconRef
  }, /*#__PURE__*/React.createElement(IconAtm, {
    icon: ArrowSvg,
    sizeSpace: 2.5
  }))), /*#__PURE__*/React.createElement(BottomRoundedCorner, {
    $size: roundedCornerIconSize,
    $backgroundColor: backgroundColor
  }, /*#__PURE__*/React.createElement(RoundedCornerIconAtm, {
    size: roundedCornerIconSize,
    color: backgroundColor
  })))));
}
export default CategoryCardMol;